// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.
// @ts-nocheck

"use client";

import {ReactNode} from "react";

import {ButtonLink} from "@/components/ui/button";
import {CtaButton} from "@/hub/components/mdx/cta-button";

export function InstallOpenTelemetryDemoButton({children}: PropsWithChildren): ReactNode {

    return (
            <CtaButton href="https://app.dash0.com/hub/integration/int_opentelemetry-demo/overview">
                Setup within Dash0
            </CtaButton>
    );
}
